var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://atreshaghayegh.com","target":"_blank"}},[_vm._v("پنل شقایق ")]),_c('span',{staticClass:"ml-1"})]),_c('div',{staticClass:"ml-auto"})])}
var staticRenderFns = []

export { render, staticRenderFns }